import { Identifier } from "react-admin";

import { AppMode } from "./permits";
import { Settings } from "./settings";
import { Space } from "./spaces";
import { ColumnsOf } from "../data";

import { Maybe } from "../utility";

export const profileType = {
  Console: "app.console",
  Mobile: "app.mobile"
} as const;

export type ProfileType = (typeof profileType)[keyof typeof profileType];

export const profileRole = {
  Admin: "admin",
  Reader: "reader",
  Writer: "writer",
  Pending: "pending"
} as const;

export type ProfileRole = (typeof profileRole)[keyof typeof profileRole];

export interface Profile {
  id: Identifier;
  name: string;
  person: Maybe<string>;
  type: Maybe<ProfileType>;
  state: Maybe<string>;
  tags: Maybe<string[]>;
  flags: Maybe<string[]>;
  config: Maybe<unknown>;
  permit_id: Maybe<string>;
  permits?: Maybe<{ name: Maybe<string> }>;
  instance: Maybe<string>;
  user_id: string;
  role: ProfileRole;
  created_at: string;
  created_by: Maybe<string>;
  email: string;
  device_id: Maybe<string>;
  space_id: Identifier;
  spaces: Maybe<Space>;
  allows: Identifier[];
  tracker: Maybe<string>;
  updated_by: Maybe<string>;
  present_at: Maybe<string>;
  accessed_at: Maybe<string>;
  confirmed_at: Maybe<string>;
  gw_internal_at?: Maybe<string>;
  gw_external_at?: Maybe<string>;
  org_id: string;
  org_name: string;
  device_type: Maybe<unknown>;
  is_online?: Maybe<boolean>;
  is_selected?: Maybe<boolean>;
  is_tracker?: Maybe<boolean>;
  app_mode?: Maybe<AppMode>;
  settings: Maybe<Settings>;
}

export const userProfileStatus = {
  Active: "Active",
  Pending: "Pending"
} as const;

export type UserStatus = (typeof userProfileStatus)[keyof typeof userProfileStatus];

export interface UserProfile extends Profile {
  status: UserStatus;
  access_to?: Space[];
  is_sso_user?: boolean;
}

export interface AppProfile extends Profile {
  access_to?: Space[];
}

export type ProfileUpdate = Partial<
  Pick<
    Profile,
    "id" | "name" | "tags" | "role" | "email" | "space_id" | "allows" | "app_mode" | "person"
  >
> & {
  settings?: Partial<Settings>;
};
export type ProfileInsert = Partial<Omit<Profile, "id" | "created_at" | "created_by">> &
  Pick<Profile, "email" | "name">;

export const APP_PROFILE_COLUMNS: ColumnsOf<AppProfile> = ["*"] as const;
export const USER_PROFILE_COLUMNS: ColumnsOf<UserProfile> = ["*"] as const;
